// Collection banner: description clamp + Read more / Read less toggle
(function () {
  'use strict';

  function initCollectionDescReadMore() {
    var descEl = document.querySelector('.collection__description');
    if (!descEl) return;

    // Wrap existing description children in an inner clamping container
    var inner = document.createElement('div');
    inner.className = 'c-col05-desc-inner';
    while (descEl.firstChild) {
      inner.appendChild(descEl.firstChild);
    }
    descEl.appendChild(inner);

    // Create Read more / Read less toggle button
    var toggle = document.createElement('button');
    toggle.className = 'c-col05-read-toggle';
    toggle.setAttribute('type', 'button');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = 'Read more';
    descEl.appendChild(toggle);

    // Show toggle only when description overflows 2 lines
    // With -webkit-line-clamp applied via CSS, scrollHeight = full height, clientHeight = clamped height
    function checkNeedsToggle() {
      // Skip while expanded: the clamp is removed, so scrollHeight/clientHeight
      // would show no overflow and incorrectly hide the (now "Read less") toggle.
      if (descEl.classList.contains('c-col05-expanded')) return;

      if (inner.scrollHeight > inner.clientHeight + 2) {
        descEl.classList.add('c-col05-has-toggle');
      } else {
        descEl.classList.remove('c-col05-has-toggle');
      }
    }

    // Double rAF to ensure CSS has been applied before measuring
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        checkNeedsToggle();
      });
    });

    window.addEventListener('resize', checkNeedsToggle);

    toggle.addEventListener('click', function () {
      var isExpanded = descEl.classList.contains('c-col05-expanded');
      if (!isExpanded) {
        // Expand: fire Intelligems event, update UI
        window.igEvents = window.igEvents || [];
        window.igEvents.push({ event: 'read_more_click' });
        descEl.classList.add('c-col05-expanded');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.textContent = 'Read less';
      } else {
        // Collapse
        descEl.classList.remove('c-col05-expanded');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = 'Read more';
      }
    });
  }

  if (document.body) {
    initCollectionDescReadMore();
  } else {
    document.addEventListener('DOMContentLoaded', initCollectionDescReadMore);
  }
})();
